import { createFileRoute } from '@tanstack/react-router';

import { AppContentPage } from '@/features/app-content/AppContentPage';

export const Route = createFileRoute('/_app/app-content/videos')({
    component: () => <AppContentPage tab="videos" />,
});
